var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.531 29.877v-14h4v14zM17.531 29.877v-13h4v13zM25.531 29.877v-12h4v12zM13.531 29.877v-15h4v15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.531 27.877v-6M27.531 27.877v-6M23.531 27.877v-3M19.531 27.877v-8",
    strokeLinecap: "round"
  })));
}

export default SvgArchive;